import Image from "next/image";

const PrimarySales = ({ data }) => {
  const { sectionTitle, mainHeading, highValueImage } = data;

  return (
    <section className="py-sp-100 sm:py-sp-big ">
      <div className="container px-3 mx-auto">

        <p className="text-base2 text-baseBlack mb-3 font-medium text-center sm:text-xl">
          {sectionTitle}
        </p>
        <h2
          className="text-heading text-baseBlack mb-12 sm:text-xl text-center"
          dangerouslySetInnerHTML={{ __html: mainHeading }}
        />

        {/* Cards */}
        <div className="flex flex-wrap justify-center gap-4">
          {highValueImage.map((item) => (
            <div
              key={item.id}
              className="bg-white border border-[#C4C4C4] rounded-xl px-4 py-8 w-[28%] sm:w-full flex flex-col items-start text-left sm:flex-row sm:gap-1 sm:px-2"
            >
              <Image
                src={item.icon}
                width={36}
                height={36}
                alt="icon"
                className="mb-2 w-auto h-auto"
              />
              <p className="text-baseBlack font-medium text-base2">
                {item.description}
              </p>
            </div>
          ))}

        </div>
      </div>
    </section>
  );
};

export default PrimarySales;